import React from 'react'
import { positionRelativeBounding, wrapper } from '../containers/App.css'
import Dropin from '../Dropin'
import { WtaiUploadWidgetProps } from '../../wtai-upload-widget'
import { cmCta, cmCtaBreak, partnerContent } from './OwlWrapper.css'

const OwlWrapper: React.FunctionComponent<WtaiUploadWidgetProps> = props => {
  const wrapperStyles = { paddingTop: '10px' }
  const bounding = { maxWidth: '600px', margin: '0 auto' }
  return (
    <div className={positionRelativeBounding} style={bounding}>
      <div className={wrapper} style={wrapperStyles}>
        <div className={partnerContent}>PARTNER CONTENT</div>
        <Dropin {...props} />
        <hr className={cmCtaBreak} />
        <div className={cmCta}>
          <div>
            <a
              href="https://owl.purdue.edu/owl/research_and_citation/using_paper_checkers_responsibly.html"
              target="_blank"
            >
              Using paper checkers responsibly
            </a>
          </div>
          <img src="https://atc.studybreakmedia.com/modules/citation-widget/images/cm_plus.png" />
        </div>
      </div>
    </div>
  )
}

export default OwlWrapper
